module.exports = function getResource(label, vars = []) {
    let resources = {
        showCard: 'Afficher la carte',
        point: 'Point',
        points: 'Points'
    };

    return resources[label];
};
